import { removeEmpty, sortObj } from "../utility/checkLib";
import httpBuildQuery from 'http-build-query';
import { md5 } from 'js-md5';
import MasterData from "./masterData";


const createMd5hashFun = (req_obj, account_secret) => {
  try {
  //  console.log(account_secret);
   
    let acSecret = MasterData.accountDetails.find((data) => { if (req_obj.account_id == data.account_id) return data.account_secret });
    let obj = {};
    obj = removeEmpty(req_obj);  // Remove empty values
    obj = sortObj(obj);
    let hashString = httpBuildQuery(obj);
    // let formattedToken = hashString.replace(/=/g, "=");
    // console.log({hashString});
    let hashWithmd5 = hashString + (acSecret == undefined ? account_secret : acSecret?.account_secret);
    // let hashWithmd5 = formattedToken + (acSecret == undefined ? account_secret : acSecret?.account_secret);
    // console.log({hashWithmd5});
    return md5(hashWithmd5);

  } catch (error) {
    console.log("error====>", error);
    return {
      error: true,
      message: error.message,
    };
  }
};

export { createMd5hashFun };
